import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { getAccountMeterpointAgreements } from "./getAccountMeterpointAgreements"
import { IAgreementDetailed } from "@/models/agreement/agreementDetailed.types"

export const getActiveMeterpointAgreements = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const agreementsQuery = getAccountMeterpointAgreements(accountNumber)
  queries.add(agreementsQuery)

  const activeMeterpointAgreements: IAgreementDetailed[] = Object.values(
    agreementsQuery.data,
  )
    .flat()
    .filter((agreement) => agreement.isActive || agreement.isPending)

  return queries.setData(activeMeterpointAgreements).getAggregate()
}
